// Strips the search params and hash from a URL
export const getPathnameFromHref = <T extends string>(href: T): T => {
  const url = new URL(href, 'http://localhost');
  return url.pathname as T;
};
